import { Component } from "@angular/core";
import { ClipboardService } from "ngx-clipboard";

import afi from "@assets/constantes/afi.json";

@Component({
  templateUrl: "./cuentasFondos.component.html",
  styleUrls: ["./cuentasFondos.component.scss"],
})
export class CuentasFondos {
  constructor(private clipboardService: ClipboardService) {}

  fondosInversion = afi.fondosInversion;

  copyCuenta(cuenta) {
    cuenta.popover = false;
    this.clipboardService.copyFromContent(cuenta.numero);
    setTimeout(() => {
      cuenta.popover = true;
    });
  }
}
